import { Translations } from "./Translations";
export class TranslationsLoader {
    load(task) {
        let url = task.url;
        return task.loader.fetch(url, "json", task.progress.createCallback(0.2), task.options).then(data => {
            if (!data)
                return null;
            let files = data.files || {};
            let jsonFile = files[Translations.provider.language];
            if (!jsonFile && Translations.provider.language != data.defaultLanguage)
                jsonFile = files[data.fallbackLanguage];
            let awaitor;
            if (jsonFile)
                awaitor = task.loader.fetch(jsonFile, "json", task.progress.createCallback(0.8), task.options);
            else
                awaitor = Promise.resolve({});
            return awaitor.then(content => {
                let inst;
                if (task.obsoluteInst && task.obsoluteInst.id == data.id)
                    inst = task.obsoluteInst;
                else
                    inst = Translations.create(data.id);
                inst.setContent(Translations.provider.language, content);
                return inst;
            });
        });
    }
}
